package org.bsvac.bsvac_kmp.data.models

enum class AgencyModel(val displayString: String) {
    BSVAC("Bedstuy Volunteer Ambulance Corps"),
    GVEMS("Gotham Volunteer Emergency Medical Services")
}